import { formatDate } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { User } from 'src/app/core/models/user';
import { AuthService } from 'src/app/core/services/auth.service';
import { BookingsService } from 'src/app/core/services/bookings.service';
import * as moment from 'moment';
import { Booking } from 'src/app/core/models/booking.model';
import { Router } from '@angular/router';
import { WriteMessageComponent } from '../write-message/write-message.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, combineLatest, from } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-upcoming-sessions',
  templateUrl: './upcoming-sessions.component.html',
  styleUrls: ['./upcoming-sessions.component.scss']
})
export class UpcomingSessionsComponent implements OnInit, OnDestroy {
  @Input()
  isInstructor: boolean;
  day: string;
  monthName: string;
  bookings: any[];
  user: User;
  dialogRef: any;
  searchRange = 'w';
  subscriptionRef: Subscription;

  constructor(private bookingService: BookingsService, private authService: AuthService, private window: Window, private router: Router, public dialog: MatDialog) {
    this.bookings = [];
  }
  openMeeting(booking: Booking): void {
    this.router.navigate(['join-meeting', booking.docId]);
  }
  ngOnInit() {
    this.day = formatDate(new Date(), 'dd', 'en') || '';
    this.monthName = formatDate(new Date(), 'MMM', 'en') || '';
    this.subscriptionRef = this.authService.currentUser?.pipe(take(1)).subscribe(user => {
      if (user) {
        this.user = user;
        console.log('USERS ', user);
        this.setUp();
      }
    });
  }
  async setUp() {
    const today = moment();
    const startOfWeek = moment().startOf('week');
    const endOfWeek = moment().endOf('week');
    this.bookings = [];
    const intBookingsDoc = await this.bookingService.getInstructorBookingsInRange(this.user.userId, startOfWeek.toDate(), endOfWeek.toDate(), true);


    const sbookingsDoc = await this.bookingService.getStudentBookingsInRange(this.user.userId, startOfWeek.toDate(), endOfWeek.toDate());


    const intBookings = intBookingsDoc;
    const sbookings = sbookingsDoc;
    if (intBookings?.length > 0) {
      this.bookings.push(intBookings.flat());
    }
    if (sbookings?.length > 0) {
      this.bookings.push(sbookings);
    }
    this.bookings = this.bookings.flat(Infinity);
    this.bookings = this.bookings.sort((a, b) => {
      if ((moment(a.startDateTime).isBefore(b.startDateTime))) {
        return 1;
      }

      if ((moment(a.startDateTime).isAfter(b.startDateTime))) {
        return -1;
      }
      return 0;
    });
  }

  async toggleSearchRange(range: string) {
    this.searchRange = range;
    const today = moment();
    let startOfWeek;
    let endOfWeek;
    switch (range) {
      case 'w':
        startOfWeek = moment().startOf('week');
        endOfWeek = moment().endOf('week');
        break;
      case 'm':
        startOfWeek = moment().startOf('month');
        endOfWeek = moment().endOf('month').add(1, 'day');
        break;
      default:
        startOfWeek = moment().startOf('week');
        endOfWeek = moment().endOf('week');
        break;

    }
    this.bookings = [];
    const intBookingsDoc = await this.bookingService.getInstructorBookingsInRange(this.user.userId, startOfWeek.toDate(), endOfWeek.toDate(), false);
    const sbookingsDoc = await this.bookingService.getStudentBookingsInRange(this.user.userId, startOfWeek.toDate(), endOfWeek.toDate());
    const intBookings = intBookingsDoc
    const sbookings = sbookingsDoc;
    if (intBookings?.length > 0) {
      this.bookings.push(intBookings.flat());
    }
    if (sbookings?.length > 0) {
      this.bookings.push(sbookings);
    }
    this.bookings = this.bookings.flat(Infinity);
    this.bookings = this.bookings.sort((a, b) => {
      if ((moment(a.startDateTime).isBefore(b.startDateTime))) {
        return 1;
      }

      if ((moment(a.startDateTime).isAfter(b.startDateTime))) {
        return -1;
      }
      return 0;
    })
    this.bookings = this.bookings.flat(Infinity);
    // combineLatest([intBookingsDoc, sbookingsDoc], (instructorBookings, studentBookings) => ({ instructorBookings, studentBookings })).pipe(map(async pair => {
    //   const intBookings = pair.instructorBookings;
    //   const sbookings = pair.studentBookings;
    //   if (intBookings?.length > 0) {
    //     this.bookings.push(intBookings.flat());
    //   }
    //   if (sbookings?.length > 0) {
    //     this.bookings.push(sbookings);
    //   }
    //   this.bookings = this.bookings.flat(Infinity);
    //   this.bookings = this.bookings.sort((a, b) => {
    //     if ((moment(a.startDateTime).isBefore(b.startDateTime))) {
    //       return 1;
    //     }

    //     if ((moment(a.startDateTime).isAfter(b.startDateTime))) {
    //       return -1;
    //     }
    //     return 0;
    //   })
    // }));
  }

  messageUser(booking: Booking) {

    const toName = this.user.userId == booking.instructorId ? booking.studentName : booking.instructorName;
    const toId = this.user.userId == booking.instructorId ? booking.studentId : booking.instructorId;
    const fromName = this.user.userId == booking.instructorId ? booking.instructorName : booking.studentName;
    this.dialogRef = this.dialog.open(WriteMessageComponent, {
      data: {
        toName: toName,
        toId: toId

      }
    });
  }

  isExpired(start) {
    let now = moment();
    now = now.add(1, 'hour');
    if (moment(start).isBefore(now)) {
      return true;
    }
    return false;
  }

  ngOnDestroy(): void {
    if (this.dialogRef != null) {
      this.dialogRef.close();
    }
    this.subscriptionRef.unsubscribe();
  }
}
